import React from "react";
import { useRouter } from '../router/hooks/index';
export default function ManagementCard({img, title, valid }){
    const router = useRouter();
    const setPage = () => {
        if(title === "GESTÃO FINANCEIRA"){
            router.push('/finance')
        } else{ 
            router.push('/animal/manage')
        }
    }
    return(
        <div className= {valid === '' ? "management_card in_active" : "management_card"} onClick={setPage}>
            <div className="icon_part">
                <img src={img} alt="" className="justify-self-center mx-auto"/>
            </div>
            <div className="content_part font-16-900">
                {title}
            </div>
        </div>
    );
}